module.exports = __webpack_public_path__ + "img/127.40851c1e.jpg";